import { SVGProps } from "react";
import * as React from "react";

export const PauseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.749 21.6022H12.249V21.5893C17.6639 21.323 21.9674 16.8171 21.9715 11.3035V11.3032C21.9715 5.61932 17.3987 1.00461 11.749 1.00461C6.09931 1.00461 1.52661 5.61985 1.52661 11.3037C1.52661 16.9875 6.09986 21.6022 11.749 21.6022ZM1.0332 11.3037C1.0332 5.33318 5.83441 0.5 11.749 0.5C17.6637 0.5 22.4649 5.33318 22.4649 11.3037C22.4649 17.2742 17.6637 22.1073 11.749 22.1073C5.83441 22.1073 1.0332 17.2742 1.0332 11.3037Z"
      fill={props.fill}
      stroke={props.stroke}
    />
    <path
      d="M13.377 8.04102H14.7703V14.5919H13.377V8.04102Z"
      fill={props.fill}
      stroke={props.stroke}
      strokeWidth="0.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.72656 8.04102H10.1199V14.5919H8.72656V8.04102Z"
      fill={props.fill}
      stroke={props.stroke}
      strokeWidth="0.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
